import '../assets/NcAssistantContent.css';
import { defineComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAssistantContent",
  props: {
    contentClasses: { default: "" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(_ctx.$style.assistantContent)
      }, [
        createElementVNode("div", {
          class: normalizeClass([_ctx.$style.assistantContent__inner, __props.contentClasses])
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2);
    };
  }
});
const assistantContent = "_assistantContent_iyAWz";
const assistantContent__inner = "_assistantContent__inner_U1ntk";
const style0 = {
  "material-design-icon": "_material-design-icon_fwhLn",
  assistantContent,
  assistantContent__inner
};
const cssModules = {
  "$style": style0
};
const NcAssistantContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAssistantContent as N
};
//# sourceMappingURL=NcAssistantContent.mjs.map
